module.exports = __webpack_public_path__ + "img/item1-3.61cd0eae.png";